import * as React from 'react';
import loadable from '@loadable/component';
import { useDispatch, useSelector } from 'react-redux';
import { ModalWindow } from '@cian/ui-kit/modal';
import { GeoSwitcher } from '../../components/GeoSwitcher';
import { LoadableErrorBoundary } from '../../components/LoadableErrorBoundary';
import { LoadableFallback } from '../../components/LoadableFallback';
import { trackGeoSwitcherClick } from './tracking';
import { IApplicationState } from '../../types/redux';
import { IGeoSwitcherState } from '../../types/geoSwitcher';
import { getPopularCities } from '../../actions/geoSwitcher';
import { selectPageKind } from '../../selectors/pageKind';

const GeoSwitcherContainerInnerLoadable = loadable(
  () => import(/* webpackChunkName: "GeoSwitcherContainerInnerLoadable" */ './GeoSwitcherContainer'),
  {
    ssr: false,
    fallback: <LoadableFallback />,
  },
);

export const GeoSwitcherWrapperContainer = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  const pageKind = useSelector(selectPageKind);
  const { region, popularCities } = useSelector<IApplicationState, IGeoSwitcherState>(state => state.geoSwitcher);

  const handleOpenGeoSwitcher = React.useCallback(() => {
    setOpen(true);
    trackGeoSwitcherClick(pageKind, region?.displayName);
  }, [pageKind, region]);

  const handleCloseGeoSwitcher = React.useCallback(() => {
    setOpen(false);
  }, []);

  const retryLoadContent = React.useCallback(() => {
    GeoSwitcherContainerInnerLoadable.load();
  }, []);

  React.useEffect(() => {
    dispatch(getPopularCities());
  }, [dispatch]);

  if (popularCities.length === 0 || !region) {
    return null;
  }

  return (
    <>
      <GeoSwitcher title={region.displayName} onClick={handleOpenGeoSwitcher} />
      <ModalWindow
        open={open}
        onClose={handleCloseGeoSwitcher}
        header={null}
        content={
          <LoadableErrorBoundary onRetry={retryLoadContent}>
            <GeoSwitcherContainerInnerLoadable closeGeoSuggest={handleCloseGeoSwitcher} />
          </LoadableErrorBoundary>
        }
        width={1179}
        size="M"
        fixed={false}
      />
    </>
  );
};
